







































































































































































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import MyForm from '@/mixins/form';
import _ from "lodash";
import { isAI, isCooperate, isTelBooking } from '@/libs/utils';

import AuditNew from '@/views/finacy/audit_new.vue';
import Settlement from '../settlement.vue';

import SettlementList from './settlement_list.vue';
import SettlementAccount from './settlement_account.vue';

@Component({
  components: {
    Settlement,
    SettlementList,
    SettlementAccount,
    AuditNew,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() stadiumName!: string;

  @Prop() settlement!: any;

  wechatForm!: any;

  settlementModalVisible = false;

  listModalVisible = false;

  accountModalVisible = false;

  waitSettlementNum = 0;

  newCheckModalVisible = false;

  wechatModalVisible = false;

  moment: (...args: any[]) => any = moment;

  isAI: (...args: any[]) => any = isAI;

  isCooperate: (...args: any[]) => any = isCooperate;

  isTelBooking: (...args: any[]) => any = isTelBooking;

  showNewCheckModal() {
    // console.log("123");
    this.newCheckModalVisible = true;
  }

  hideNewCheckModal() {
    this.newCheckModalVisible = false;
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: '确认信息',
          content: '确定要提交吗？',
          onOk: async () => {
            // 保存
          },
        });
      }
    });
  }

  showAccountModal() {
    if (!this.checkPermission('admin-stadium-bank')) {
      this.$message.error('没有权限admin-stadium-bank');
      return;
    }
    this.accountModalVisible = true;
  }

  hideAccountModal() {
    this.accountModalVisible = false;
  }

  showListModal() {
    this.listModalVisible = true;
  }

  hideListModal() {
    this.listModalVisible = false;
  }

  showSettlementModal() {
    if (!this.checkPermission('admin-stadium-settlement')) {
      this.$message.error('没有权限admin-stadium-settlement');
      return;
    }
    this.settlementModalVisible = true;
  }

  hideSettlementModal() {
    this.settlementModalVisible = false;
  }

  showWechatModal() {
    if (!this.checkPermission('admin-stadium-settlement')) {
      this.$message.error('没有权限admin-stadium-settlement');
      return;
    }
    this.wechatModalVisible = true;
  }

  hideWechatModal(){
    this.wechatModalVisible = false;
  }

  async setFieldValue(val: any) {
    // this.$confirm({
    //   title: '确认信息',
    //   content: `您确定要${val === false ? '下线' : '上线'}该场馆吗？`,
    //   onOk: async () => {
    this.changeFieldValue(
      this.form,
      {
        tblname: 'stadium_setting',
        fieldname: 'is_profit',
        fieldlabel: '是否分账',
        content: '修改场馆是否分账',
        primaryname: 'stadium_id',
        primaryval: this.stadiumId,
        oldval: this.formData.is_profit,
      },
      'admin-stadium-bank',
    );
    // }
    // })
  }

  // async loadWaitSettlement() {
  //   const res = await this.$store.dispatch("stadium/waitSettlement", {
  //     stadium_id: this.stadiumId
  //   });
  //   if (res && res.Data && res.Data !== "{}") {
  //     this.waitSettlementNum = Number(res.Data) / 100;
  //   }
  // }

  async loadDetail() {
    const res = await this.$store.dispatch('stadium/settingDetail', {
      stadium_id: this.stadiumId,
    });
    if (res && res.Data && res.Data !== '{}') {
      this.formData = res.Data;
    }
  }

  mounted() {
    this.loadDetail();
    this.wechatForm = this.$form.createForm(this);
    // this.loadWaitSettlement();
  }

  handleWechat() {
    this.wechatForm.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        // console.log(fieldsValue);
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const fieldname = "wechat_url";
            const res = await this.$store.dispatch("stadium/settingChange", {
              stadium_id: this.stadiumId,
              fieldname,
              fieldval: fieldsValue.wechat_url,
              content: "设置微信商户"
            });
            if (res && res.Message && res.Message === "success") {
              _.set(this.formData, [fieldname], fieldsValue.wechat_url);
              this.hideWechatModal();
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }


}
